export const normalizeNumbers = (value: number, fixed?: number): string => {
  const absValue = !value ? 0 : Number(Math.abs(value));
  const typeUnits = ["k", "m", "b"];

  let abbr = "";

  const trillion = 1000000000000,
    billion = 1000000000,
    million = 1000000,
    thousand = 1000;
  let retNumber: number | string = absValue;

  if ((absValue >= 0 && absValue < 10) || (absValue < 0 && absValue > -10)) {
    abbr = "";
  } else if (
    (absValue >= 10 && absValue < 100) ||
    (absValue <= -10 && absValue > -100)
  ) {
    abbr = "";
  } else if (
    (absValue >= 100 && absValue < thousand) ||
    (absValue <= -100 && absValue > thousand)
  ) {
    abbr = "";
    retNumber = formatNumber(retNumber);
  } else if (
    (absValue >= thousand && absValue < million) ||
    (absValue <= thousand && absValue > million)
  ) {
    abbr = typeUnits?.[0] || "";
    retNumber = calculateAndDivide(absValue, fixed);
  } else if (
    (absValue >= million && absValue < billion) ||
    (absValue <= million && absValue > billion)
  ) {
    abbr = typeUnits?.[1] || "";

    retNumber = calculateAndDivide(absValue / 1000, fixed);
  } else if (
    (absValue >= billion && absValue < trillion) ||
    (absValue <= billion && absValue > trillion)
  ) {
    abbr = typeUnits?.[2] || "";
    retNumber = calculateAndDivide(absValue / 1000000, fixed);
  }

  return `${retNumber}${abbr}`;
};

const calculateAndDivide = (
  value: number,
  fixed?: number,
): number | string => {
  let result: string;
  if (value < 10000) {
    result = (value / 1000).toFixed(fixed ? fixed : 2);
  } else if (value < 100000) {
    result = (value / 1000).toFixed(fixed ? fixed : 1);
  } else {
    result = (value / 1000).toFixed(fixed ? fixed : 0);
  }

  try {
    return parseFloat(result);
  } catch (error) {
    return "Error converting value to number";
  }
};

export const daySuffix = (day: number): string => {
  switch (day) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

const numberFormatter = new Intl.NumberFormat();

export const formatNumber = (number: unknown): string => {
  if (!isNumber(number)) {
    return number as string;
  }
  return numberFormatter.format(number as number);
};

export const isNumber = (number: unknown): boolean => {
  return !isNaN(number as number) && number !== null && number !== undefined;
};
